import { currentEnvironment } from "../application/lib/environment";

export function initPostHog() {
  if (currentEnvironment() !== "production") return;
  if (document.body.dataset.impersonated === "true") return;
  if (document.body.dataset.currentUserEmail?.includes("@loadar.com")) return;

  if (document.body.dataset.currentUserEmail) {
    posthog.identify(document.body.dataset.currentUserEmail);
  }
}
